module.exports = __webpack_public_path__ + "media/Gosser_Spritz_6_Sec_V1.7ea9ab9a.mp4";